export default "__VITE_ASSET__Chzq8z6t__"